module.exports = __webpack_public_path__ + "img/TRIANGLE.bb2f2643.webp";